const bidTitle = (
  product: {
    hasBid: boolean;
    isFinished: boolean;
  },
  currentUser?: {
    hasBid: boolean;
    isTopBidder: boolean;
  },
) => {
  if (product.isFinished && product.hasBid) {
    return "product.card.winningBid";
  }

  if (product.isFinished && !product.hasBid) {
    return "product.card.finalPrice";
  }

  if (!product.isFinished && currentUser?.isTopBidder) {
    return "product.biddingSection.topBidder";
  }

  if (!product.isFinished && currentUser?.hasBid) {
    return "product.biddingSection.outbid";
  }

  if (!product.isFinished && product.hasBid) {
    return "product.card.currentBid";
  }

  return "product.card.startBidding";
};

export default bidTitle;
